import { CustomerPayment, mapPaymentScheduleStatusEnumToText, PaymentScheduleStatus } from "../model";
import { ColumnDef } from "@tanstack/react-table";

export const customersColumns: ColumnDef<CustomerPayment>[] = [
  {
    header: "Booking date",
    accessorFn: (r) => (
      <>
        {r.booking.bookingDateFrom}
        <br />
        {r.booking.bookingDateTo}
      </>
    ),
    cell: ({ getValue }) => getValue(),
  },
  {
    header: "Yacht booked",
    accessorFn: (r) => (r.booking.yacht.name ? r.booking.yacht.name : "-"),
  },
  {
    header: "Supplier",
    accessorFn: (r) => (r.booking.yacht.operator.name ? r.booking.yacht.operator.name : "-"),
  },
  {
    header: "Payment status",
    accessorFn: (r) => {
      let bgColor = "";
      let textColor = "";

      switch (r.status) {
        case PaymentScheduleStatus.OVERDUE:
          bgColor = "bg-red-400";
          textColor = "text-secondary-foreground";
          break;
        case PaymentScheduleStatus.FULLY_PAID:
          bgColor = "bg-green-300";
          textColor = "text-secondary-foreground";
          break;
        case PaymentScheduleStatus.PARTIALLY_PAID:
          bgColor = "bg-green-500";
          textColor = "text-secondary-foreground";
          break;
        case PaymentScheduleStatus.WAITING:
          bgColor = "bg-yellow-400";
          textColor = "text-secondary-foreground";
          break;
        default:
          bgColor = "bg-gray-200";
          textColor = "text-gray-600";
      }

      return (
        <span className={`inline-block rounded-full ${bgColor} ${textColor} px-3 py-1 text-nowrap`}>
          {mapPaymentScheduleStatusEnumToText(r.status)}
        </span>
      );
    },
    cell: ({ getValue }) => getValue(),
  },
  {
    header: "Payment due",
    accessorFn: (r) => r.dueDate,
  },
  {
    header: "Booking amount",
    accessorFn: (r) => r.bookingAmount,
  },
  {
    header: "Payment schedule step amount",
    accessorFn: (r) => r.amount,
  },
  {
    header: "Paid so far",
    accessorFn: (r) => (r.paidSoFar ? r.paidSoFar : "-"),
  },
  {
    header: "Currency",
    accessorFn: (r) => (r.booking?.currency?.code ? r.booking?.currency.code : "-"),
  },
];
